import React from "react";
import { ArrowUpRight } from "lucide-react";
import { attorneyImgStyle } from "../lib/attorneyImage";

export default function AttorneyCard({ attorney, onClick }) {
  return (
    <button
      onClick={onClick}
      className="attorney-card group text-left bg-white border border-stone-200 overflow-hidden flex flex-col justify-start focus:outline-none focus:ring-2 focus:ring-[#1a2c4e]/30"
    >
      <div className="aspect-[4/5] overflow-hidden bg-stone-100 relative">
        <img
          src={attorney.image}
          alt={attorney.name}
          className="attorney-img w-full h-full object-cover"
          style={attorneyImgStyle(attorney)}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a2c4e]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute bottom-4 right-4 w-10 h-10 bg-white text-[#1a2c4e] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
          <ArrowUpRight className="w-5 h-5" />
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-serif text-2xl text-[#1a2c4e] leading-tight">{attorney.name}</h3>
        <div className="text-xs uppercase tracking-[0.2em] text-[#b8924a] mt-2">{attorney.title}</div>
        <div className="h-px w-10 bg-stone-300 my-4" />
        <p className="text-sm text-[#4a6d8c]">
          {attorney.practiceAreas.slice(0, 3).join(" \u00b7 ")}
        </p>
      </div>
    </button>
  );
}
